import React from 'react';

import {yupResolver} from '@hookform/resolvers/yup';
import {useStore} from 'effector-react';
import i18next from 'i18next';
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import * as yup from 'yup';

import {downloadMarkingCOdesByTINS} from 'api';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Input} from 'components/ui-kit/Input';
import {Modal} from 'components/ui-kit/Modal';
import {Select, SelectOption} from 'components/ui-kit/Select';
import {
    currentGtin$,
    currentGtinChanged,
    fetchLabelsEvent,
    Gate,
    productsData$,
} from 'models/orders/detail';

import {
    ErrorMessage,
    FooterContainer,
    FormContainer,
    FormItem,
    FormItemContainer,
    FormItemDescription,
} from './styled';

const getSheme = (maxCount?: number) =>
    yup.object().shape({
        format: yup.string().required(i18next.t('components.form.required')),
        quantity: yup
            .number()
            .typeError(i18next.t('components.form.onlyNums'))
            .positive(i18next.t('components.form.positive'))
            .max(maxCount || 500, `${i18next.t('pages.orders.print.max')}: ${maxCount || 500}`)
            .required(i18next.t('components.form.required')),
    });

const FORMATS = [
    // {label: 'CSV', value: 'CSV'},
    {label: 'PDF', value: 'PDF'},
];

export const PrintModal = () => {
    const {t} = useTranslation();
    const {id} = useStore(Gate.state);
    const currentGtin = useStore(currentGtin$);
    const products = useStore(productsData$);
    const currentProduct = products.find((item) => item.gtin === currentGtin);

    const {control, handleSubmit, formState, errors} = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        resolver: yupResolver(getSheme(currentProduct?.availableQuantity)),
        defaultValues: {
            format: FORMATS[0].value,
            quantity: '',
        },
    });

    const onDownloadCSV = async () => {
        try {
            if (!currentGtin) throw Error('GTIN is required');
            const response = await downloadMarkingCOdesByTINS({gtin: currentGtin, orderId: id});
            saveAs(response, `marking_codes_${id}_${currentGtin}.csv`);
        } catch (err) {
            console.error('Error:', err);
        }
    };

    const Footer = () => (
        <FooterContainer>
            <Button onClick={() => currentGtinChanged(null)} variant={ButtonVariant.Outline}>
                {t('pages.orders.print.cancel')}
            </Button>
            <Button
                variant={ButtonVariant.Normal}
                disabled={!formState.isValid}
                onClick={handleSubmit(onHandleChanged)}
            >
                {t('pages.orders.print.submit')}
            </Button>
            <Button variant={ButtonVariant.Text} onClick={onDownloadCSV}>
                {t('pages.orders.detail.common.download')}
            </Button>
        </FooterContainer>
    );

    const onHandleChanged = (data: any) => {
        fetchLabelsEvent({
            orderId: id,
            gtin: currentGtin,
            template: 'white',
            ...data,
        });
    };

    return (
        <Modal
            show={!!currentGtin}
            onClose={() => currentGtinChanged(null)}
            modalWidth={0}
            footer={<Footer />}
            title={t('pages.orders.print.label')}
        >
            <FormContainer>
                <form>
                    <FormItem>
                        <Controller
                            control={control}
                            name="format"
                            render={(props, {invalid}) => (
                                <Select
                                    onChange={(val: SelectOption<string>) => {
                                        props.onChange(val.value);
                                    }}
                                    value={
                                        FORMATS.filter(
                                            (el: SelectOption<string>) => el.value === props.value,
                                        )[0]
                                    }
                                    label={t('pages.orders.print.format')}
                                    hasError={invalid}
                                    options={FORMATS}
                                />
                            )}
                        />
                    </FormItem>
                    <FormItemContainer>
                        <div style={{display: 'flex'}}>
                            <Controller
                                control={control}
                                name="quantity"
                                render={(props, {invalid}) => (
                                    <Input
                                        {...props}
                                        label={t('pages.orders.print.quantity')}
                                        hasError={invalid}
                                        autoComplete="off"
                                    />
                                )}
                            />
                            <FormItemDescription>
                                {t('pages.orders.print.quantity_max')}
                            </FormItemDescription>
                        </div>
                        {errors?.quantity && (
                            <ErrorMessage>{errors?.quantity?.message}</ErrorMessage>
                        )}
                    </FormItemContainer>
                    {/*<FormLabel>{t('pages.orders.print.templateRadio')}</FormLabel>*/}
                    {/*<RadioButtonContainer>*/}
                    {/*    <div>*/}
                    {/*        <input type="radio" checked={false} disabled={true} />*/}
                    {/*        <span>{t('pages.orders.print.customTemplate')}</span>*/}
                    {/*    </div>*/}
                    {/*    <div>*/}
                    {/*        <input type="radio" checked={true} disabled={true} />*/}
                    {/*        <span>{t('pages.orders.print.baseTemplate')}</span>*/}
                    {/*    </div>*/}
                    {/*</RadioButtonContainer>*/}
                    {/*<FormItem>*/}
                    {/*    <Select*/}
                    {/*        label={t('pages.orders.print.template')}*/}
                    {/*        options={[*/}
                    {/*            {label: t('pages.orders.print.whiteTemplate'), value: 'white'},*/}
                    {/*        ]}*/}
                    {/*        value={{label: t('pages.orders.print.whiteTemplate'), value: 'white'}}*/}
                    {/*    />*/}
                    {/*</FormItem>*/}
                    {/* <FormLabel>{t('pages.orders.print.preview')}</FormLabel>
                    <ImagePreview /> */}
                </form>
            </FormContainer>
        </Modal>
    );
};
